import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Spinner } from "../components/ui/spinner";

const GoogleCallbackPage = () => {
  const [status, setStatus] = useState("処理中...");
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleGoogleCallback = async () => {
      try {
        setStatus("Google認証を処理中...");
        
        // URLパラメータから認証結果を取得
        const params = new URLSearchParams(location.search);
        const error = params.get('error');
        
        if (error) {
          setError(`Google認証エラー: ${decodeURIComponent(error)}`);
          setStatus("認証に失敗しました");
          return;
        }

        // 認証成功の場合、ダッシュボードへリダイレクト
        setStatus("認証が完了しました。リダイレクト中...");
        setTimeout(() => {
          navigate('/dashboard');
        }, 2000);

      } catch (err) {
        console.error("Google callback error:", err);
        setError("Google認証処理中にエラーが発生しました");
        setStatus("エラーが発生しました");
      }
    };

    handleGoogleCallback();
  }, [navigate, location]);

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-600 via-purple-600 to-indigo-700 flex items-center justify-center p-4">
        <Card className="w-full max-w-md">
          <CardHeader className="text-center space-y-2">
            <div className="mx-auto w-12 h-12 bg-destructive rounded-full flex items-center justify-center">
              <svg className="w-6 h-6 text-destructive-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <CardTitle className="text-xl font-bold text-destructive">認証エラー</CardTitle>
            <CardDescription className="text-destructive">
              {error}
            </CardDescription>
          </CardHeader>
          <CardContent className="text-center">
            <button
              onClick={() => navigate('/login')}
              className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90"
            >
              ログインページに戻る
            </button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-600 via-purple-600 to-indigo-700 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center space-y-2">
          <div className="mx-auto w-12 h-12 bg-primary rounded-full flex items-center justify-center">
            <Spinner size="lg" />
          </div>
          <CardTitle className="text-xl font-bold">Google認証中</CardTitle>
          <CardDescription>
            {status}
          </CardDescription>
        </CardHeader>
        <CardContent className="text-center">
          <div className="flex items-center justify-center space-x-2">
            <Spinner size="sm" />
            <span className="text-sm text-muted-foreground">処理中...</span>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default GoogleCallbackPage;
